import React, { useState, useEffect } from "react";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";

export default function LeftFilterPanel({ onFilterChange, mode = "finance", projects = [] }) {
    const [collapsed, setCollapsed] = useState(true);
    const [dateRange, setDateRange] = useState(null);
    const [selectedProject, setSelectedProject] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);

    const statusOptions = [
        { label: "All statuses", value: null },
        { label: "Open", value: "open" },
        { label: "Closed", value: "closed" },
        { label: "In Progress", value: "in progress" },
    ];

    const projectOptions = [
        { label: "All projects", value: null },
        ...projects.map((p) => ({ label: p.name, value: p.id })),
    ];

    useEffect(() => {
        if (onFilterChange) {
            onFilterChange({
                dateRange,
                projectId: selectedProject,
                status: selectedStatus,
            });
        }
    }, [dateRange, selectedProject, selectedStatus, onFilterChange]);

    return (
        <div
            style={{
                width: collapsed ? 60 : 280,
                background: "#f7f8fa",
                borderRight: "1px solid #eee",
                display: "flex",
                flexDirection: "column",
                padding: collapsed ? "16px 0" : "24px 16px",
                transition: "width 0.3s ease",
                overflow: "hidden",
            }}
        >
            <button
                onClick={() => setCollapsed((c) => !c)}
                style={{
                    marginBottom: 20,
                    padding: 0,
                    width: 36,
                    height: 36,
                    cursor: "pointer",
                    alignSelf: collapsed ? "center" : "flex-end",
                    background: "transparent",
                    border: "none",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "background 0.2s",
                    lineHeight: 1,
                    zIndex: 10,
                    pointerEvents: "auto",
                }}
                aria-label={collapsed ? "Expand filters" : "Collapse filters"}
                tabIndex={0}
                onMouseOver={(e) => (e.currentTarget.style.background = "#e0e7ff")}
                onMouseOut={(e) => (e.currentTarget.style.background = "transparent")}
            >
                <span
                    style={{
                        fontSize: 22,
                        color: "var(--primary-color)",
                        display: "inline-block",
                        verticalAlign: "middle",
                        lineHeight: 1,
                        height: 22,
                        width: 22,
                        textAlign: "center",
                        transition: "transform 0.2s, color 0.2s",
                        transform: collapsed ? "rotate(0deg)" : "rotate(180deg)",
                    }}
                >
                    ▶
                </span>
            </button>

            {!collapsed && (
                <>
                    {/* Date Range — shown in both modes */}
                    <label htmlFor="date-range" style={{ marginBottom: 8, fontWeight: "600", fontSize: 13 }}>
                        Fecha
                    </label>
                    <Calendar
                        id="date-range"
                        value={dateRange}
                        onChange={(e) => setDateRange(e.value)}
                        selectionMode="range"
                        dateFormat="yy-mm-dd"
                        placeholder="Select date range"
                        showIcon
                        style={{ marginBottom: 24, width: "100%" }}
                    />

                    {/* Operations-only filters */}
                    {mode === "operations" && (
                        <>
                            <label style={{ marginBottom: 8, fontWeight: "600", fontSize: 13 }}>Project</label>
                            <Dropdown
                                value={selectedProject}
                                options={projectOptions}
                                onChange={(e) => setSelectedProject(e.value)}
                                placeholder="All projects"
                                style={{ marginBottom: 24, width: "100%" }}
                            />

                            <label style={{ marginBottom: 8, fontWeight: "600", fontSize: 13 }}>Task Status</label>
                            <Dropdown
                                value={selectedStatus}
                                options={statusOptions}
                                onChange={(e) => setSelectedStatus(e.value)}
                                placeholder="All statuses"
                                style={{ marginBottom: 24, width: "100%" }}
                            />

                            {(selectedProject || selectedStatus) && (
                                <button
                                    onClick={() => {
                                        setSelectedProject(null);
                                        setSelectedStatus(null);
                                    }}
                                    style={{
                                        background: "transparent",
                                        border: "1px solid #d1d5db",
                                        borderRadius: 6,
                                        padding: "6px 12px",
                                        cursor: "pointer",
                                        fontSize: 12,
                                        color: "#6b7280",
                                    }}
                                >
                                    Clear filters
                                </button>
                            )}
                        </>
                    )}
                </>
            )}
        </div>
    );
}
